(() => {
  document.documentElement.classList.remove("no-js");

  const selectors = {
    cartDrawer: "#CartDrawer",
    cartBody: "[data-cart-drawer-body]",
    cartCount: "[data-cart-count]",
    headerCartCount: "[data-header-cart-count]",
    cartTotal: "[data-cart-total]",
  };

  const escapeHtml = (value = "") =>
    String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const money = (cents) =>
    new Intl.NumberFormat("en-PK", {
      style: "currency",
      currency: "PKR",
      maximumFractionDigits: 0,
    })
      .format((Number(cents) || 0) / 100)
      .replace("PKR", "Rs.");

  const drawer = document.querySelector(selectors.cartDrawer);

  const openCart = () => {
    if (!drawer) return;
    if (typeof drawer.showModal === "function") drawer.showModal();
    document.body.classList.add("dialog-open");
  };

  const closeCart = () => {
    if (!drawer) return;
    drawer.close();
    document.body.classList.remove("dialog-open");
  };

  document.querySelectorAll("[data-open-cart]").forEach((button) => {
    button.addEventListener("click", openCart);
  });

  document.querySelectorAll("[data-close-cart]").forEach((button) => {
    button.addEventListener("click", closeCart);
  });

  if (drawer) {
    drawer.addEventListener("click", (event) => {
      if (event.target === drawer) closeCart();
    });
  }

  const renderCart = (cart) => {
    document.querySelectorAll(selectors.cartCount).forEach((node) => {
      node.textContent = cart.item_count;
    });
    document.querySelectorAll(selectors.headerCartCount).forEach((node) => {
      node.textContent = cart.item_count;
    });

    const total = document.querySelector(selectors.cartTotal);
    if (total) total.textContent = money(cart.total_price);

    const body = document.querySelector(selectors.cartBody);
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<div class="empty-state"><p>Your cart is ready when you are.</p></div>';
      return;
    }

    body.innerHTML = cart.items
      .map(
        (item) => `
          <article class="drawer-item">
            <img src="${escapeHtml(item.image || "")}" alt="" width="70" height="70" loading="lazy">
            <div>
              <a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
              <small>${escapeHtml(item.variant_title || "")} · Qty ${item.quantity}</small>
              <strong>${money(item.final_line_price)}</strong>
            </div>
          </article>
        `,
      )
      .join("");
  };

  const refreshCart = async () => {
    const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("Cart could not be refreshed.");
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  document.querySelectorAll("[data-quick-add], .product-form").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      if (submit) {
        submit.disabled = true;
        submit.setAttribute("aria-busy", "true");
      }

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || "This item could not be added.");
        }

        await refreshCart();
        openCart();
      } catch (error) {
        window.alert(error.message);
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.removeAttribute("aria-busy");
        }
      }
    });
  });

  const menuButton = document.querySelector("[data-menu-toggle]");
  const mobileMenu = document.querySelector("[data-mobile-menu]");
  if (menuButton && mobileMenu) {
    menuButton.addEventListener("click", () => {
      const open = menuButton.getAttribute("aria-expanded") === "true";
      menuButton.setAttribute("aria-expanded", String(!open));
      mobileMenu.hidden = open;
    });
  }

  const searchInput = document.querySelector("[data-predictive-search]");
  const searchResults = document.querySelector("[data-predictive-results]");
  let searchTimer;

  const renderSearch = (products) => {
    if (!searchResults) return;
    if (!products.length) {
      searchResults.innerHTML = '<p class="empty-state">No matching products found.</p>';
      searchResults.hidden = false;
      return;
    }

    searchResults.innerHTML = products
      .map(
        (product) => `
          <a class="predictive-item" href="${escapeHtml(product.url)}">
            <img src="${escapeHtml(product.featured_image?.url || "")}" alt="" width="54" height="54" loading="lazy">
            <span>
              <strong>${escapeHtml(product.title)}</strong>
              <small>${escapeHtml(product.vendor || "")}</small>
            </span>
            <b>›</b>
          </a>
        `,
      )
      .join("");
    searchResults.hidden = false;
  };

  if (searchInput && searchResults) {
    searchInput.addEventListener("input", () => {
      window.clearTimeout(searchTimer);
      const query = searchInput.value.trim();
      if (query.length < 2) {
        searchResults.hidden = true;
        return;
      }

      searchTimer = window.setTimeout(async () => {
        try {
          const response = await fetch(
            `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`,
            { headers: { Accept: "application/json" } },
          );
          if (!response.ok) throw new Error();
          const data = await response.json();
          renderSearch(data.resources?.results?.products || []);
        } catch {
          searchResults.hidden = true;
        }
      }, 220);
    });

    document.addEventListener("click", (event) => {
      if (!event.target.closest("[data-search-shell]")) searchResults.hidden = true;
    });
  }

  document.querySelectorAll("[data-media-target]").forEach((button) => {
    button.addEventListener("click", () => {
      const target = button.dataset.mediaTarget;
      document.querySelectorAll("[data-media-id]").forEach((media) => {
        media.hidden = media.dataset.mediaId !== target;
      });
    });
  });

  document.querySelectorAll("[data-product-section]").forEach((section) => {
    const select = section.querySelector("[data-variant-select]");
    const radios = section.querySelectorAll('.variant-fieldset input[type="radio"]');
    if (!select || !radios.length) return;
    const price = section.querySelector("[data-product-price]");
    const submit = section.querySelector('.product-form [type="submit"]');

    const updateVariant = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === "true";
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? section.dataset.addLabel : section.dataset.soldLabel;
      }
    };

    select.addEventListener("change", updateVariant);

    radios.forEach((radio) => {
      radio.addEventListener("change", () => {
        const optionNames = [...section.querySelectorAll(".variant-fieldset")]
          .map((fieldset) => fieldset.querySelector('input[type="radio"]:checked')?.value)
          .filter(Boolean);
        const title = optionNames.join(" / ");
        const option = [...select.options].find((item) => item.textContent.trim().startsWith(title));
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    });

    updateVariant();
  });

  const filterToggle = document.querySelector("[data-filter-toggle]");
  const filters = document.querySelector("[data-filters]");
  if (filterToggle && filters) {
    filterToggle.addEventListener("click", () => {
      const open = filters.classList.toggle("is-open");
      filterToggle.setAttribute("aria-expanded", String(open));
    });
  }

  const sortSelect = document.querySelector("[data-sort-by]");
  if (sortSelect) {
    sortSelect.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sortSelect.value);
      window.location.assign(url.toString());
    });
  }

  document.querySelectorAll("[data-slideshow]").forEach((slideshow) => {
    const slides = [...slideshow.querySelectorAll("[data-slide]")];
    const buttons = [...slideshow.querySelectorAll("[data-slide-button]")];
    if (slides.length < 2) return;

    let active = 0;
    let timer;
    const delay = Number(slideshow.dataset.delay) || 7000;
    const autoplay =
      slideshow.dataset.autoplay === "true" &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const showSlide = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === active;
        slide.classList.toggle("is-active", selected);
        slide.setAttribute("aria-hidden", String(!selected));
      });
      buttons.forEach((button, buttonIndex) => {
        const selected = buttonIndex === active;
        button.classList.toggle("is-active", selected);
        button.setAttribute("aria-current", String(selected));
      });
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      if (!autoplay) return;
      stop();
      timer = window.setInterval(() => showSlide(active + 1), delay);
    };

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        showSlide(Number(button.dataset.slideButton));
        start();
      });
    });

    slideshow.addEventListener("mouseenter", stop);
    slideshow.addEventListener("mouseleave", start);
    slideshow.addEventListener("focusin", stop);
    slideshow.addEventListener("focusout", start);
    start();
  });

  document.querySelectorAll("[data-video-stories]").forEach((section) => {
    const stories = [...section.querySelectorAll("[data-video-story]")];
    const copies = [...section.querySelectorAll("[data-video-story-copy]")];
    const buttons = [...section.querySelectorAll("[data-video-story-button]")];
    let isVisible = false;

    const showStory = (id) => {
      stories.forEach((story) => {
        const selected = story.dataset.videoStory === id;
        story.hidden = !selected;
        story.classList.toggle("is-active", selected);
        const video = story.querySelector("video");
        if (!video) return;
        if (selected && isVisible && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
      copies.forEach((copy) => {
        const selected = copy.dataset.videoStoryCopy === id;
        copy.hidden = !selected;
        copy.classList.toggle("is-active", selected);
      });
      buttons.forEach((button) => {
        const selected = button.dataset.videoStoryButton === id;
        button.classList.toggle("is-active", selected);
        button.setAttribute("aria-pressed", String(selected));
      });
    };

    buttons.forEach((button) => {
      button.addEventListener("click", () => showStory(button.dataset.videoStoryButton));
    });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          isVisible = entry.isIntersecting;
          section.querySelectorAll("video").forEach((video) => {
            if (!entry.isIntersecting) video.pause();
            else if (!video.closest("[hidden]") && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
              video.play().catch(() => {});
            }
          });
        },
        { rootMargin: "160px 0px", threshold: 0.08 },
      );
      observer.observe(section);
    }
  });

  document.querySelectorAll(".application-form").forEach((form) => {
    form.addEventListener("submit", () => {
      if (!form.checkValidity()) return;
      const button = form.querySelector('[type="submit"]');
      if (!button) return;
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.textContent = "Sending…";
    });
  });

  let petSoundsOn = false;
  let petAudio;
  const playPetSound = (kind, force = false) => {
    if (!petSoundsOn && !force) return;
    const AudioCtor = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtor) return;
    petAudio ||= new AudioCtor();
    if (petAudio.state === "suspended") petAudio.resume();
    const now = petAudio.currentTime;
    const gain = petAudio.createGain();
    gain.connect(petAudio.destination);
    gain.gain.setValueAtTime(0.0001, now);

    if (kind === "purr") {
      const carrier = petAudio.createOscillator();
      const pulse = petAudio.createOscillator();
      const pulseGain = petAudio.createGain();
      carrier.type = "triangle";
      carrier.frequency.setValueAtTime(82, now);
      pulse.type = "sine";
      pulse.frequency.setValueAtTime(25, now);
      pulseGain.gain.setValueAtTime(0.045, now);
      pulse.connect(pulseGain);
      pulseGain.connect(gain.gain);
      carrier.connect(gain);
      gain.gain.exponentialRampToValueAtTime(0.055, now + 0.06);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 1.15);
      carrier.start(now);
      pulse.start(now);
      carrier.stop(now + 1.2);
      pulse.stop(now + 1.2);
      return;
    }

    const oscillator = petAudio.createOscillator();
    oscillator.connect(gain);
    oscillator.type = kind === "cat" ? "sawtooth" : "square";
    oscillator.frequency.setValueAtTime(kind === "cat" ? 520 : 170, now);
    if (kind === "cat") {
      oscillator.frequency.exponentialRampToValueAtTime(880, now + 0.18);
      oscillator.frequency.exponentialRampToValueAtTime(390, now + 0.55);
      gain.gain.exponentialRampToValueAtTime(0.055, now + 0.04);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.6);
      oscillator.stop(now + 0.62);
    } else {
      oscillator.frequency.exponentialRampToValueAtTime(95, now + 0.16);
      gain.gain.exponentialRampToValueAtTime(0.07, now + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.22);
      oscillator.stop(now + 0.24);
    }
    oscillator.start(now);
  };

  document.querySelectorAll("[data-pet-sound-toggle]").forEach((button) => {
    button.addEventListener("click", () => {
      petSoundsOn = !petSoundsOn;
      button.classList.toggle("is-on", petSoundsOn);
      button.setAttribute("aria-pressed", String(petSoundsOn));
      button.setAttribute("aria-label", `Pet sounds ${petSoundsOn ? "on" : "off"}`);
      if (petSoundsOn) playPetSound("purr", true);
    });
  });

  document.querySelectorAll(".desktop-nav a, .mobile-quick-nav a, .mobile-menu a").forEach((link) => {
    link.addEventListener("click", () => {
      const label = link.textContent.toLowerCase();
      if (label.includes("cat")) playPetSound("cat");
      if (label.includes("dog")) playPetSound("dog");
    });
  });

  document.querySelectorAll("[data-quick-add], .product-form").forEach((form) => {
    form.addEventListener("submit", () => playPetSound("purr"));
  });

  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const targets = document.querySelectorAll(
      ".shopify-section:not(.shopify-section-group-header-group), .site-footer",
    );
    targets.forEach((target) => target.classList.add("reveal-ready"));
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          observer.unobserve(entry.target);
        }
      }),
      { threshold: 0.08 },
    );
    targets.forEach((target) => observer.observe(target));
  }
})();
